import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    // position: 'relative',
    // flex: 1,
    padding: '0 15px',
    // height: 'calc(100% - 58px)',
    overflow: 'hidden',
    borderRadius: 0,
    height: '100%',
    borderRight:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main
    //backgroundColor: "inherit",
  },
  chatList: {
    display: 'flex',
    flexDirection: 'column'
    // backgroundColor: theme.palette.blue_50.main,
    // position: 'relative',
    // flex: 1,
    // overflowY: 'scroll',
    // ...theme.scrollbarStyles,
    // '&:hover': {
    //   backgroundColor: theme.palette.blue_50.main
    // }
  },
  listBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },
  listItem: {
    borderRadius: '8px',
    cursor: 'pointer',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_700.main
        : theme.palette.gray_50.main,
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main + ' !important'
          : theme.palette.blue_50.main + ' !important'
    }
  },
  listItemText: {
    maxWidth: '85%'
  },
  boxTitleNewChat: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  titleNewChat: {
    fontWeight: '600',
    color: theme.palette.blue_300.main,
    fontSize: '.875rem'
  },
  badgeCountMessage: {
    width: '22px',
    height: '22px',
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main
  },
  lastMessage: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '290px',
    width: '100%'
  },
  lastMessageTime: {
    color: theme.palette.gray_400.main,
    fontSize: '11px'
  },
  emptyList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    height: '100%',
    padding: '8px',
    textAlign: 'center',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.white_100.main,
    '& svg': {
      color: theme.palette.blue_300.main
    }
  },
  emptyListTextTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontWeight: '600',
    fontSize: '1rem',
    color: theme.palette.blue_300.main
  },
  containerActionButtons: {
    display: 'flex',
    gap: '4px',
  },
  actionEditButton: {
    padding: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.blue_50.main,
      color: theme.palette.blue_300.main
    }
  },
  actionDeleteButton: {
    padding: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_700.main
          : theme.palette.red_50.main,
      color: theme.palette.red_100.main
    }
  }
}))
